const formatDate = {
  toSend: (data, split = false) => {
    if (!data) return null;

    const year = String(data.getFullYear()).padStart(4, "0");
    const month = String(data.getMonth() + 1).padStart(2, "0");
    const day = String(data.getDate()).padStart(2, "0");

    const dateString = `${year}-${month}-${day}`;

    return split ? dateString : `${dateString}T03:00:00.000Z`;
  },

  received: (data) => {
    return data ? new Date(data) : new Date();
  },

  format: (date) => {
    if (!date) return new Date();

    if (date instanceof Date) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    if (date.includes("T")) {
      const [year, month, day] = date.split("T")[0].split("-");
      return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    }

    const [year, month, day] = date.split("-");
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  },
};

export default formatDate;
